module.exports = __webpack_public_path__ + "static/media/24UHCHR26.6e0ce5fe.jpg";